<template>
  <div class="role-page full-height">
  <table-con>
    <div slot="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>数据字典管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div slot="search">
      <el-row class="search-row">
        <el-col :span="6" class="display-row">
          <div class="query-title">名称区分:</div>
          <div class="flex1">
            <el-input placeholder="请输入内容" clearable v-model="queryInfo.nameClass" size="small"
                      @keyup.enter.native="searchDictionary(true)">
            </el-input>
          </div>
        </el-col>

        <el-col :span="18" class="display-row">
          <div style="text-align:right;width:100%;padding-right:10px">
            <el-button class="search-btn btn-blue" @click="searchDictionary(true)">搜索</el-button>
            <el-button class="search-btn btn-green" @click="addDictionary">添加</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div slot="table" class="full-height display-col">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="DictionaryList" border
                height="550" class="tablebox">
        <el-table-column prop="num" label="序号" align="center" width="40">
        </el-table-column>
        <el-table-column prop="nameClass" label="名称区分" align="center" width="250">
        </el-table-column>
        <el-table-column prop="nameCd" label="名称编号" align="center" width="250">
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center" width="250">
        </el-table-column>
        <el-table-column prop="nameZh" label="中文名称" align="center" width="250">
        </el-table-column>
        <el-table-column prop="data" align="center" label="数据">
        </el-table-column>
        <el-table-column prop="sortKey" align="center" label="排序">
        </el-table-column>

        <el-table-column width="300" align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="list-btn btn-deepblue" @click="editDictionary(scope.row)">编辑</el-button>
            <el-button class="list-btn btn-warn" type="danger" @click="delDictionary(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
                     :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
    </div>
  </table-con>
  <!-- 添加字典 -->
  <el-dialog title="新增数据字典" :visible.sync="addDictionaryDialogVisible" width="50%" @close="addDictionaryDialogClose">
    <el-form :model="editDictionaryInfo" :rules="rules" ref="dialogForm" label-width="180px" class="add-role-form">
      <el-form-item label="名称区分：" prop="nameClass">
        <el-input v-model="editDictionaryInfo.nameClass" size="small"></el-input>
      </el-form-item>
      <el-form-item label="名称编号：" prop="nameCd">
        <el-input v-model="editDictionaryInfo.nameCd" size="small"></el-input>
      </el-form-item>
      <el-form-item label="名称：" prop="name">
        <el-input v-model="editDictionaryInfo.name" size="small"></el-input>
      </el-form-item>
      <el-form-item label="中文名称：" prop="nameZh">
        <el-input v-model="editDictionaryInfo.nameZh" size="small"></el-input>
      </el-form-item>
      <el-form-item label="值：">
        <el-input v-model="editDictionaryInfo.data" size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="editDictionaryInfo.sortKey" size="small"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="editDictionaryInfo.notes" size="small"></el-input>
      </el-form-item>
      <el-form-item label="包装收费项（用于检品）：" v-if="editDictionaryInfo.nameClass == 'INSPECTION'">
        <el-select v-model="editDictionaryInfo.isPackage" placeholder="请选择" size="small" clearable>
          <el-option key="0" label="否（退货不返还费用）" value="0"></el-option>
          <el-option key="1" label="是（退货返还费用）" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button class="form-btn btn-gray" @click="clearaddDictionaryForm">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="addDictionarySave">提 交</el-button>
        </span>
  </el-dialog>

  <!-- 编辑字典 -->
  <el-dialog title="编辑数据字典" :visible.sync="editDictionaryDialogVisible" width="50%" @close="editDictionaryDialogClose">
    <el-form :model="editDictionaryInfo" :rules="rules" ref="dialogForm" label-width="180px" class="add-role-form">
      <el-form-item label="名称区分：" prop="nameClass">
        <el-input v-model="editDictionaryInfo.nameClass" size="small"></el-input>
      </el-form-item>
      <el-form-item label="名称编号：" prop="nameCd">
        <el-input v-model="editDictionaryInfo.nameCd" size="small"></el-input>
      </el-form-item>
      <el-form-item label="名称：" prop="name">
        <el-input v-model="editDictionaryInfo.name" size="small"></el-input>
      </el-form-item>
      <el-form-item label="中文名称：" prop="nameZh">
        <el-input v-model="editDictionaryInfo.nameZh" size="small"></el-input>
      </el-form-item>
      <el-form-item label="值：">
        <el-input v-model="editDictionaryInfo.data" size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="sortKey">
        <el-input v-model="editDictionaryInfo.sortKey" size="small"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="editDictionaryInfo.notes" size="small"></el-input>
      </el-form-item>
      <el-form-item label="包装收费项（用于检品）：" v-if="editDictionaryInfo.nameClass == 'INSPECTION'">
        <el-select v-model="editDictionaryInfo.isPackage" placeholder="请选择" size="small" clearable>
          <el-option key="0" label="否（退货不返还费用）" value="0"></el-option>
          <el-option key="1" label="是（退货返还费用）" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button class="form-btn btn-gray" @click="clearaddDictionaryForm">取 消</el-button>
          <el-button class="form-btn btn-blue" @click="DictionarySave">提 交</el-button>
        </span>
  </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
export default {
  components: { tableCon },
  data () {
    return {
      rules: {
        nameClass: [
          { required: true, message: '名称区分不能为空', trigger: 'blur' }
        ],
        nameCd: [
          { required: true, message: '名称编号不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        sortKey: [{ pattern: /^(0|[1-9]\d?|99)$/, message: '范围在0-99', trigger: 'blur' }
        ],

      },
      queryInfo: {
        nameClass: '',
        pageSize: 10,
        pageNum: 1
      },
      DictionaryList: [],
      total: 0,
      editDictionaryInfo: {

      },
      editDictionaryDialogVisible: false,
      addDictionaryDialogVisible: false,
      authEditParams: {
        roleId: '',
        roleMenuPermList: []
      },
      authTreeSelectedId: [],
      authTreeData: [],
      defaultProps: {
        children: 'menuTreeChild',
        label: 'menuName',
        id: 'menuId'
      },
    }
  },
  methods: {
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getDictionaryList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getDictionaryList();
    },
    editDictionaryDialogClose () {
      this.editDictionaryDialogVisible = false;
    },
    addDictionaryDialogClose () {
      this.addDictionaryDialogVisible = false;
    },

    clearaddDictionaryForm () {
      this.initRoleForm();
      this.editDictionaryDialogVisible = false;
      this.addDictionaryDialogVisible = false;
    },
    DictionarySave () {
      this.modifyDictionary();
    },
    addDictionarySave () {
      this.addDictionarypost();
    },
    searchDictionary (flag) {
      if (flag) {
        this.queryInfo.pageNum = 1;
        console.log(this.queryInfo);
        this.getDictionaryList();
      } else {
        this.getDictionaryList();
      }

    },
    addDictionary () {
      this.addDictionaryDialogVisible = true;
    },
    initRoleForm () {
      this.editDictionaryInfo = {
        id: '',
        nameClass: '',
        nameCd: '',
        name: '',
        nameZh: '',
        data: '',
        sortKey: '',
        notes: '',
        isPackage:'',
      }
    },

    // 删除选中的数据字典
    async delDictionary (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var url = 'CmsName/delName';
        const { data: res } = await this.$http.post(url, { id: row.id });
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.message
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
        this.getDictionaryList();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      /*var url = 'CmsName/delName';
      const { data: res } = await this.$http.post(url, { id: row.id });
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getDictionaryList();*/
    },
    editDictionary (row) {
      this.editDictionaryDialogVisible = true;
      this.editDictionaryInfo = JSON.parse(JSON.stringify(row));
    },
    //新增数据字典
    async addDictionarypost () {
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          var url = 'CmsName/addName';
          const { data: res } = await my.$http.post(url, my.editDictionaryInfo);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
                my.initRoleForm();
            my.addDictionaryDialogVisible = false;
            my.getDictionaryList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    async getDictionaryList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.post('CmsName/getAllName', this.queryInfo);
      console.log(res);
      res.data.list.map((item, index) => {
        item.num = index + 1
      })
      this.DictionaryList = res.data.list;
      this.total = res.data.total;
    },
    // 修改/编辑 数据字典
    async modifyDictionary () {
      console.log(this.editDictionaryInfo);
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        if (valid) {
          var url = 'CmsName/editName';
          const { data: res } = await my.$http.post(url, my.editDictionaryInfo);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
                my.editDictionaryDialogVisible = false;
            my.getDictionaryList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },

  },

  created () {
    this.getDictionaryList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
